import type {
  GenerateMentorReferralCodeBody,
  GenerateMentorReferralCodeResponse,
  ListMentorReferralsParams,
  ListMentorReferralsResponse,
} from '$shared/api';
import { BaseService } from './utils/BaseService';

export class AcceleratorService extends BaseService {
  generateMentorReferralCode(
    body: GenerateMentorReferralCodeBody,
  ): Promise<GenerateMentorReferralCodeResponse> {
    return this.client.send('/api/accelerator/generate-mentor-referral', {
      method: 'POST',
      body,
    });
  }

  listMentorReferrals(
    query?: ListMentorReferralsParams,
  ): Promise<ListMentorReferralsResponse> {
    return this.client.send('/api/accelerator/mentor-referrals', {
      method: 'GET',
      query,
    });
  }

  public async deleteMentorReferralCode(code: string): Promise<void> {
    await this.client.send(`/api/accelerator/mentor-referrals/${code}`, {
      method: 'DELETE',
    });
  }
}
